var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ins',{staticClass:"adsbygoogle",staticStyle:{"display":"inline-block","width":"1000px","height":"90px"},attrs:{"data-ad-client":"ca-pub-2962728463844483","data-ad-slot":"5235599329"}})}
var staticRenderFns = []

export { render, staticRenderFns }